module.exports = __webpack_public_path__ + "media/images/endicott_flag-17a563fb37b1194568cbbb0455f55a94.jpg";